import { render, staticRenderFns } from "./ModalUbahPassword.vue?vue&type=template&id=1803ea64"
import script from "./ModalUbahPassword.vue?vue&type=script&lang=js"
export * from "./ModalUbahPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports